import React, { PureComponent } from 'react';
import './Portfolio.css';
import styled from 'styled-components';
import Project from './Project';


const MyPortfolio = styled.h1`
    // padding-top: 100px;
    color: #aac9f0;
    padding-bottom: 30px;
`


const Thumbnail = styled.img`
    width: 100%;
    height: 100%;
`

const Description = styled.p`
    font-size: 18px

`

function Portfolio(){

    return (
        <div className="Portfolio" id = "Portfolio">

            <div className="description">
                <MyPortfolio> My Portfolio </MyPortfolio>
            </div>

            <div className="container">
                
                <a href="https://github.com/R3mpty/AI-Project"><Project imgSrc = "/images/flappy.png" imgAlt="Flappy Bird"  text = "This was my A-Level project where I looked into Q-learning and genetic algorithms. The app has to versions, one using q-tables while the other is made with the help of a library called NEAT" header = "AI Flappy Bird" onClick = {() => {console.log("clicked")}} /></a>
            
                <a href="https://github.com/R3mpty/memory-game"><Project imgSrc = "/images/TheCircle.png" imgAlt="The Circle"  text = "The goal of the game is to click no card more than twice while the cards shuffles each round. This was made with react where I played around with various hooks" header = "Memory Cards"  /></a>
            
                <a href="https://github.com/R3mpty/Tic-Tac-Toe"><Project imgSrc = "/images/Tictactie.gif" imgAlt="Tic Tac Toe"  text = "Playing with the minimax algorithm. The project is made with react" header =  "Minimax TicTacToe"/></a>

                <a href=""><Project imgSrc = "/images/gameOfLife.gif" imgAlt="Game of life"  text = "My first look into celluar automation. The project is made with react and styled with tailwind CSS a " header = "Game of life"  /></a>

                <a href="https://github.com/R3mpty/weatherApp"><Project imgSrc = "/images/weather.gif" imgAlt="Flappy Bird"  text = "Experimenting with openWeather API, practicing asynchronous Javascript concpets, as well as familiarizing with tailwind CSS" header = "Weather App"/></a>

                <a href="https://github.com/R3mpty/Etch-A-Sketch"><Project imgSrc = "/images/etch.gif" imgAlt="Flappy Bird"  text = "Playing around with event listeners and manipulating DOM elements" header = "Etch a Sketch"  /></a>

                
            </div>


            <a href="https://github.com/R3mpty"><button id = "seeMore"> See more </button></a>
           

        </div>
    )

}

export default Portfolio;